import {
  TmLayout,
  TmLogo,
  TmHeader,
  TmLink,
  TmFooter,
  TmFooterLinks,
  TmMain,
  TmAlert,
  TmBox,
  TmCard,
  TmRow,
  TmCol,
  TmInput,
  TmFlex,
  TmButton,
  TmIcon,
  TmPassword,
  TmSpinner,
  TmCheckbox,
  TmDivider,
  TmCollapsible,
  TmContainer,
  TmDefinition,
  TmDefinitionItem,
  TmIndicator,
  TmTooltip
} from '@tmcz/tmcz-vue-ui';

export function init(vue) {
  vue.component('TmLayout', TmLayout);
  vue.component('TmLogo', TmLogo);
  vue.component('TmLogo', TmLogo);
  vue.component('TmHeader', TmHeader);
  vue.component('TmLink', TmLink);
  vue.component('TmFooter', TmFooter);
  vue.component('TmFooterLinks', TmFooterLinks);
  vue.component('TmMain', TmMain);
  vue.component('TmAlert', TmAlert);
  vue.component('TmBox', TmBox);
  vue.component('TmCard', TmCard);
  vue.component('TmRow', TmRow);
  vue.component('TmCol', TmCol);
  vue.component('TmInput', TmInput);
  vue.component('TmFlex', TmFlex);
  vue.component('TmButton', TmButton);
  vue.component('TmIcon', TmIcon);
  vue.component('TmPassword', TmPassword);
  vue.component('TmSpinner', TmSpinner);
  vue.component('TmCheckbox', TmCheckbox);
  vue.component('TmDivider', TmDivider);
  vue.component('TmCollapsible', TmCollapsible);
  vue.component('TmContainer', TmContainer);
  vue.component('TmDefinition', TmDefinition);
  vue.component('TmDefinitionItem', TmDefinitionItem);
  vue.component('TmIndicator', TmIndicator);
  vue.component('TmTooltip', TmTooltip);
}
